export const APP_VERSION = "1.1.1";

export function shouldBypassServiceWorkerCache(method: string, pathname: string): boolean {
  return method.toUpperCase() !== "GET" || pathname.startsWith("/api/");
}

export function isServiceWorkerUpdateReady(state: ServiceWorkerState, hasController: boolean): boolean {
  return state === "installed" && hasController;
}

export async function registerServiceWorker(onUpdate: (registration: ServiceWorkerRegistration) => void) {
  if (!("serviceWorker" in navigator)) return null;
  const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  if (registration.waiting) onUpdate(registration);
  registration.addEventListener("updatefound", () => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener("statechange", () => {
      if (isServiceWorkerUpdateReady(worker.state, Boolean(navigator.serviceWorker.controller))) onUpdate(registration);
    });
  });
  return registration;
}

export function activateServiceWorkerUpdate(registration: ServiceWorkerRegistration) {
  registration.waiting?.postMessage({ type: "SKIP_WAITING" });
}
